"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var scrollToTop_1 = require("../../../../../utils/scrollToTop");
var JurisdictionPicker_1 = require("../JurisdictionPicker/JurisdictionPicker");
var wizardNavigationButtons_1 = require("../../wizardNavigationButtons");
var Jurisdiction = function (props) {
    (0, scrollToTop_1.default)();
    return (React.createElement("div", { className: "add-debt-wizard-page flex-column" },
        React.createElement("div", { className: "add-debt-wizard-form-contents flex-column" },
            React.createElement("div", { className: "wizard-form-description" },
                React.createElement("h2", null, "Debt Jurisdiction"),
                React.createElement("p", null, "Choose which legal jurisdiction you will use to enforce your debt claim.")),
            React.createElement("div", null,
                React.createElement("div", { className: "form-panel" },
                    React.createElement(JurisdictionPicker_1.default, { setFieldValue: props.setFieldValue, values: props.values, validator: props.validator })))),
        React.createElement(wizardNavigationButtons_1.default, { previousPath: '/dashboard/debtwizard/page4', nextPath: '/dashboard/debtwizard/page6' })));
};
exports.default = Jurisdiction;
